import React from 'react';
import { objOne } from './Data';
import { Button } from '../../Button'
import Layout from './Layout';
import GetTAF from '../MetarTAF/GetTAF';
import GetICM from './GetICM';
// import GetMETAR from '../MetarTAF/GetMETAR';
import DTG from '../../DTG';

export default function MSD({
  lightBg,
  topLine,
  lightText,
  lightTextDesc,
  headline,
  alternate,
  eppw,
  epby,
  eply,
  buttonLabel,
  img,
  alt,
  imgStart
}) {

  const AD = ['EPIR', 'EPPW', 'EPBY', 'EPLY'];

  return (
    <>
      <div className='container'>

        <DTG />
        <div
          className='row home__hero-row'
          style={{
            display: 'flex',
          }}
        >
          <div className='col'>
            <div className='home__hero-text-wrapper'>
              <div className='top-line'>INOWROCŁAW-LATKOWO</div>
              <h1 className='heading'>
                EPIR
              </h1>
              <div className='home__hero-subtitle'>
                <div className="homeMetar">
                  {/* {GetMETAR(AD[0], 0)} */}
                </div>
              </div>
              <div className='home__hero-subtitle'>

                <div className="homeTaf">
                  {GetTAF(AD[0], 0)}
                </div>
              </div>
            </div>
            <div className='alternate-line'>
              LOTNISKA ZAPASOWE
            </div>

            {GetTAF(AD[1], 0)}
            {GetTAF(AD[2], 1)}
            {GetTAF(AD[3], 0)}

          </div>

          <div className='col'>
            <div className='home__hero-img-wrapper'>
              {/* <img src={img} alt={alt} className='home__hero-img' /> */}
              
              <GetICM/>
              
              
              

              <a
                href="https://m.meteo.pl/inowroclaw/60"
                target="_blank"
                title="EPIR ICM Meteo"
                rel="noreferrer">
                <Button >
                  SPRAWDŹ ICM
                </Button>
              </a>

            </div>
          </div>


        </div>

        {/* <Layout {...objOne} /> */}

      </div>
    </>
  );
}